'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extractValue = require('../../attribute/extractValue.attribute');

var _extractValue2 = _interopRequireDefault(_extractValue);

var _type = require('../type');

var _type2 = _interopRequireDefault(_type);

var _dmvNJLicense = require('./dmvNJLicense.type');

var _dmvNJLicense2 = _interopRequireDefault(_dmvNJLicense);

var _dmvNYLicense = require('./dmvNYLicense.type');

var _dmvNYLicense2 = _interopRequireDefault(_dmvNYLicense);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // import dmvLicense from './dmvLicense.type';


var stateBasedFn = function stateBasedFn(dmv_license_state, fn) {
  var state = (0, _extractValue2.default)(dmv_license_state);

  switch (state) {
    case 'NY':
      return _dmvNYLicense2.default[fn];

    default:
      return _dmvNJLicense2.default[fn];
    // default:
    //   return dmvLicense[fn];
  }
};

var format = function format(input, prev) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$dmv_license_stat = _ref.dmv_license_state,
      dmv_license_state = _ref$dmv_license_stat === undefined ? 'default' : _ref$dmv_license_stat;

  return stateBasedFn(dmv_license_state, 'format')(input, prev);
};

var validate = function validate(value, prev) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$dmv_license_sta = _ref2.dmv_license_state,
      dmv_license_state = _ref2$dmv_license_sta === undefined ? 'default' : _ref2$dmv_license_sta;

  return stateBasedFn(dmv_license_state, 'validate')(value);
};

exports.default = (0, _type2.default)({
  type: 'string',
  format: format,
  validate: validate
});